import React, { Fragment, Suspense } from 'react';
import componentFactory from '../../components/ComponentFactory';
import { customSuperJsonParse, customSuperJsonStringify, customJsonstringify } from './Utils';
import Loader from '../../adapters/helpers/Loader';
import LazyLoad from 'react-lazy-load';
import DOMPurify from "isomorphic-dompurify";
class ArticleBlock {
  constructor(props) {
    var _this$article, _this$article2, _props$article;
    this.props = props;
    this.article = props.article;
    this.contents = props.contents || ((_this$article = this.article) == null ? void 0 : _this$article.contents) || [];
    this.contentIndex = props.contentIndex || 0;
    this.promotions = props.promotions || ((_this$article2 = this.article) == null ? void 0 : _this$article2.relatedPromotions) || [];
    this.promotionIndex = props.promotionIndex || 0;
    this.blockIndex = props.blockIndex || 0;
    this.relatedblocks = props.blocks || (props == null ? void 0 : (_props$article = props.article) == null ? void 0 : _props$article.blocks) || [];
  }
  renderBlock(moduleClass, attributes, moduleBody) {
    const moduleDefinition = componentFactory.getModule(moduleClass);
    if (moduleDefinition) {
      const module = React.createElement(moduleDefinition, attributes, moduleBody);
      return module;
    } else {
      console.info('Unsupported module type : ' + moduleClass);
    }
  }
  renderHtmlBlock(attributes) {
    let {
      classNames,
      anchorId,
      textContent
    } = attributes.extraAttributes.richTextBlock.fields;
    return <div id={anchorId} className={`ob-html-block ${classNames}`} dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(textContent)
    }}></div>;
  }
  renderRelatedblocks(items) {
    for (let i = 0; i <= this.relatedblocks.length; i++) {
      if (this.relatedblocks[i].fields.contentType === 'contentBlock') {
        return items;
      }
    }
  }
  renderBlockFromDocument(extraAttributes, onClickCallback, customEvent, index) {
    const document = this.getDocument();
    if (document && document.fields && document.fields.contentType) {
      var _attributes$extraAttr, _attributes$extraAttr2, _attributes$extraAttr3;
      let contentType = document.fields.contentType;
      let blockName = document.fields.name;
      let className = document.fields.classNames;
      let attributes = {
        name: blockName,
        document: document,
        className: className,
        onClickCallback,
        customEvent,
        key: blockName,
        index,
        ...extraAttributes
      };
      if (attributes == null ? void 0 : (_attributes$extraAttr = attributes.extraAttributes) == null ? void 0 : (_attributes$extraAttr2 = _attributes$extraAttr.richTextBlock) == null ? void 0 : (_attributes$extraAttr3 = _attributes$extraAttr2.fields) == null ? void 0 : _attributes$extraAttr3.textContent) {
        return this.renderHtmlBlock(attributes);
      } else {
        return this.renderBlock(contentType, attributes, null);
      }
    } else {
      var _this$props, _this$props$page, _this$props$page$fiel;
      console.error('Unsupported block is currently assign to page:' + ((_this$props = this.props) == null ? void 0 : (_this$props$page = _this$props.page) == null ? void 0 : (_this$props$page$fiel = _this$props$page.fields) == null ? void 0 : _this$props$page$fiel.name));
    }
  }

  /**
   * Render the modules assigned to the page.
   * @returns {*}
   */
  renderChildBlocks(extraAttributes, onClickCallback, customEvent) {
    const doc = this.getDocument();
    return doc.fields && doc.fields.blocks ? <Suspense fallback={<Loader />}>
             <Fragment>
                {doc.fields.blocks.map((child, index) => {
          if (this.isRenderable(child)) {
            var _this$article3;
            let extraAttributesClone = JSON.parse(customJsonstringify(extraAttributes));
            let currentExtraAttributes = this.reassignExtraAttributes(extraAttributesClone, child);
            const props = {
              document: child,
              article: this.article,
              contents: this.contents,
              contentIndex: this.contentIndex,
              promotions: this.promotions,
              promotionIndex: this.promotionIndex,
              className: ((_this$article3 = this.article) == null ? void 0 : _this$article3.className) || ''
            };
            return new ArticleBlock(props).renderBlockFromDocument(currentExtraAttributes, onClickCallback, customEvent, index);
          }
        })}
            </Fragment>
            </Suspense> : null;
  }
  getDocument() {
    let doc = this.props.document;
    if (doc == null) {
      doc = this.props;
    }
    if (!doc) {
      doc = {};
    }
    return doc;
  }
  isRenderable(document) {
    if (document.fields.contentType == 'promoBlock') {
      return this.promotionIndex < this.promotions.length;
    } else if (document.fields.contentType == 'richTextBlock') {
      return this.contentIndex < this.contents.length;
    } else {
      return true;
    }
  }
  reassignExtraAttributes(extraAttributes, document) {
    if (document.fields.contentType == 'promoBlock' && this.promotions.length > 0) {
      extraAttributes['extraAttributes']['promo'] = this.promotions[this.promotionIndex];
      if (this.promotionIndex < this.promotions.length) {
        this.promotionIndex++;
      }
    }
    if (document.fields.contentType == 'richTextBlock' && this.contents.length > 0) {
      extraAttributes['extraAttributes']['richTextBlock'] = this.contents[this.contentIndex];
      if (this.contentIndex < this.contents.length) {
        this.contentIndex++;
      }
    }
    return extraAttributes;
  }
}
export default ArticleBlock;